// import CognitoAuth from "@/services/CognitoAuthService";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "readVinNumber",
    component: () => import("../components/agsrs/ReadVinNumber.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/postSerialNumber",
    name: "postSerialNumber",
    component: () => import("../components/agsrs/PostSerialNumber.vue"),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if(from.name === "readVinNumber" || from.name === "judgePattern"){
        next()
      } else {
        next({ path: "/" });
      }
    }  
  },
  {
    path: "/judgePattern",
    name: "judgePattern",
    component: () => import("../components/agsrs/DisplayWorkPattern.vue"),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if(from.name === "readVinNumber" || from.name === "postSerialNumber"){
        next()
      } else {
        next({ path: "/" });
      }
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
